import React, { useState } from 'react';
import { useTurnstile } from '@orrekie/shared/hooks';

const TurnstileTest = () => {
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);

  const {
    ready: turnstileReady,
    error: turnstileError,
    getTurnstileToken,
    renderWidget,
    resetWidget,
    token
  } = useTurnstile('test');

  const testTurnstile = async () => {
    setLoading(true);
    setResult('');

    try {
      if (!turnstileReady) {
        setResult('❌ Turnstile is not ready');
        return;
      }

      setResult('🔄 Getting Turnstile token...');
      const token = await getTurnstileToken('turnstile-test-widget');
      setResult(`✅ Turnstile token received: ${token.substring(0, 20)}...`);

    } catch (error) {
      setResult(`❌ Turnstile error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const resetTurnstile = () => {
    resetWidget('turnstile-test-widget');
    setResult('');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Turnstile Test
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Test Turnstile integration
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-4">Status</h3>
              <div className="space-y-2">
                <div className="flex items-center">
                  <span className="text-sm font-medium text-gray-700">Turnstile Ready:</span>
                  <span className={`ml-2 text-sm ${turnstileReady ? 'text-green-600' : 'text-red-600'}`}>
                    {turnstileReady ? '✅ Yes' : '❌ No'}
                  </span>
                </div>

                <div className="flex items-center">
                  <span className="text-sm font-medium text-gray-700">Site Key:</span>
                  <span className="ml-2 text-sm text-gray-600">
                    {import.meta.env.VITE_TURNSTILE_SITE_KEY ? '✅ Set' : '❌ Missing'}
                  </span>
                </div>

                {turnstileError && (
                  <div className="flex items-center">
                    <span className="text-sm font-medium text-red-700">Error:</span>
                    <span className="ml-2 text-sm text-red-600">{turnstileError}</span>
                  </div>
                )}
              </div>
            </div>

            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-4">Test Widget</h3>
              <div id="turnstile-test-widget" className="mb-4" />

              <div className="space-y-2">
                <button
                  onClick={testTurnstile}
                  disabled={loading || !turnstileReady}
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loading ? 'Testing...' : 'Test Turnstile'}
                </button>

                <button
                  onClick={resetTurnstile}
                  className="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  Reset Widget
                </button>
              </div>
            </div>

            {result && (
              <div className={`p-3 rounded-md ${result.startsWith('✅') ? 'bg-green-100 text-green-700' :
                result.startsWith('❌') ? 'bg-red-100 text-red-700' :
                  'bg-blue-100 text-blue-700'
                }`}>
                {result}
              </div>
            )}

            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-4">Current Token</h3>
              <div className="bg-gray-100 p-3 rounded-md">
                <pre className="text-xs text-gray-700 break-all">
                  {token || 'No token available'}
                </pre>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-4">Environment Info</h3>
              <div className="bg-gray-100 p-3 rounded-md text-sm">
                <div><strong>Mode:</strong> {import.meta.env.MODE}</div>
                <div><strong>Site Key Set:</strong> {import.meta.env.VITE_TURNSTILE_SITE_KEY ? 'Yes' : 'No'}</div>
                <div><strong>Site Key Preview:</strong> {import.meta.env.VITE_TURNSTILE_SITE_KEY ? `${import.meta.env.VITE_TURNSTILE_SITE_KEY.substring(0, 10)}...` : 'Not set'}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TurnstileTest; 